import { AppRouteRecordRaw } from '../types';
import { ETranslationModule } from '@/i18n/translation';

const Body = () => import('@/components/body.vue');
const PaymentMethod = () => import('@/pages/account-management/payment-method/PaymentMethod.vue');
const PayByInvoicePage = () =>
  import('@/pages/account-management/payment-method/PayByInvoicePage.vue');
const InvoiceManagement = () =>
  import('@/pages/fleetManagement/myFleet/invoices/InvoiceManagement.vue');
const ListPriceManagement = () => import('@/pages/list-prices/ListPriceManagement.vue');
const AccountSettings = () => import('@/pages/accountsettings/AccountSettings.vue');

export const accountManagement: AppRouteRecordRaw[] = [
  {
    path: '/account-management',
    component: Body,
    meta: {
      i18nModules: [ETranslationModule.fleet, ETranslationModule.paymentMethod],
      breadcrumb: 'Account Management',
    },
    children: [
      {
        path: 'payment-method',
        name: 'paymentMethodRoot',
        redirect: { name: 'paymentMethod' },
        meta: {
          breadcrumb: 'Payment Method',
        },
        children: [
          {
            path: '',
            name: 'paymentMethod',
            component: PaymentMethod,
            meta: {
              title: 'Account Management - Payment Method | ryd Portal',
              headTitle: 'Payment Method',
            },
          },
          {
            path: 'pay-by-invoice',
            name: 'payByInvoice',
            component: PayByInvoicePage,
            meta: {
              title: 'Account Management - Pay by Invoice | ryd Portal',
              breadcrumb: 'Pay by Invoice',
              headTitle: 'Pay by Invoice Setup',
            },
          },
        ],
      },
      {
        path: 'invoices',
        name: 'invoices',
        component: InvoiceManagement,
        meta: {
          title: 'Account Management - Invoices | ryd Portal',
          breadcrumb: 'Invoices',
          headTitle: 'Invoice Management',
        },
      },
    ],
  },
  {
    path: '/account-management/list-prices',
    component: Body,
    meta: {
      requiresAuth: true,
      requiresListPrice: true,
      breadcrumb: 'Account Management',
    },
    children: [
      {
        path: '',
        name: 'listPrices',
        component: ListPriceManagement,
        meta: {
          title: ' List Prices | ryd Portal',
          breadcrumb: 'List Prices',
          headTitle: 'List Prices History',
        },
      },
    ],
  },
  // rederect to cover incorect path
  { path: '/list-price', redirect: '/account-management/list-prices' },
  // Backward-compat redirect: List Prices moved to Account Management.
  { path: '/list-prices', redirect: '/account-management/list-prices' },
  {
    path: '/account-management/account-settings',
    component: Body,
    meta: {
      title: 'Partner Portal Account Settings | ryd Portal',
      breadcrumb: 'Account Management',
    },
    children: [
      {
        path: '',
        name: 'accountSettings',
        component: AccountSettings,
        meta: {
          breadcrumb: 'Account Settings',
        },
      },
    ],
  },
  // Backward-compat redirects: Account Settings moved to Account Management.
  { path: '/account-settings', redirect: '/account-management/account-settings' },
  { path: '/pages/account-settings', redirect: '/account-management/account-settings' },
];
